import { List } from "immutable";
import _ from "lodash";
import React from "react";
import { ExperienceEditor, RelocationEditor, EducationEditor } from "./";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import { Contacts } from "../../../../constants";
import { CareerCenterJobCategories } from "../../../../domain/CareerCenterJobCategories";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { Utility } from "../../../../utils";

interface OwnProps {
    api: Api;
    cancelLink?: string;
    countries: List<M.Country.Country>;
    includeSubscribe?: boolean;
    isUpdate?: boolean;
    onSubmit: (model: Forms.CareerCenter.PostResumeData, body: any) => void;
}

interface OwnState {
}

export class PostResumeForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    // private _isMounted = false;

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.CareerCenter.PostResume();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public async componentDidMount() {
        // this._isMounted = true;
    }

    public componentWillUnmount() {
        // this._isMounted = false;
    }

    public setFormDataFromResume(resume: M.CareerCenter.Resume) {
        const formModel = { ...this.state.formModel } as Forms.CareerCenter.PostResume;
        formModel.data.categoryId = resume.categoryId;
        formModel.data.coverLetter = resume.coverLetter || "";
        formModel.data.cv = resume.cvMedia ? {
            fileName: resume.cvMedia.fileName,
            guid: resume.cvMedia.guid,
            size: resume.cvMedia.size,
            url: resume.cvMedia.url,
        } : undefined,
        formModel.data.title = resume.title;
        formModel.data.education = resume.educations.map((e, i) => ({
                id: e.id,
                index: i,
                isDelete: false,
                completedOn: Utility.fromApiDate(e.completedOn),
                organization: e.organization || "",
                typeId: e.typeId,
            })),
        formModel.data.experience = resume.experiences.map((e, i) => ({
                id: e.id,
                index: i,
                isDelete: false,
                organization: e.organization || "",
                position: e.position || "",
            })),
        formModel.data.relocationPref = resume.relocationPrefs.map((r, i) => ({
                id: r.id,
                index: i,
                isDelete: false,
                location: {
                    city: r.location.city || "",
                    state: r.location.state || "",
                    countryCode: {
                        label: r.location.country || "",
                        value: r.location.countryCode || "",
                        isoCode: r.location.countryCode,
                    },
                },
                region: r.location.region
                    ? {
                        label: r.location.region,
                        value: r.location.region,
                        region: r.location.region,
                    }
                    : undefined,
            })),
        formModel.data.subscribe = resume.subscribed;
        this.setState({ ...this.state, formModel });
    }

    public render() {
        const categories: M.Editors.SelectItem[] = _.orderBy(CareerCenterJobCategories.Values, "sort").map((c) => ({
            id: c.id,
            render: c.name,
            selected: false,
        }));

        const subscribeForm = this.props.includeSubscribe === undefined || this.props.includeSubscribe
            ? <Comp.Generic.WrapperLess>
                <hr />
                <h2>Job Alerts</h2>

                <Comp.Editors.FormField name="">
                    <p>
                        Receive automated email notifications whenever new jobs that match your job category become available.
                        Unsubscribe at any time.
                    </p>
                </Comp.Editors.FormField>
                <Comp.Editors.CheckboxField formComponent={this} name="subscribe" />
            </Comp.Generic.WrapperLess>
            : null;

        return <Comp.Validation.ValidatedForm
                formComponent={this}
                model={this.state.formModel.data}
                onValidSubmit={(model) => this.handleValidSubmit(model)}
                schema={this.state.formModel.rules}
                ref={(ref: any) => this.form = ref}
            >
                <Comp.Generic.RequiredFields />

                <h2>CV/Resume</h2>

                <Comp.Editors.FileUploaderField
                    formComponent={this}
                    name="cv"
                    onClearFile={(file) => this.clearResumeCV(file)}
                    uploader={{
                        filters: {
                            max_file_size: "10mb",
                            mime_types: [
                                { title: "Documents", extensions: "doc,docx,pdf,rtf,txt" },
                            ],
                            prevent_duplicates: true,
                        },
                        url: Api.endpoints.users.careerCenter.uploadCV.absoluteApiUrl(),
                    }}
                />

                <Comp.Editors.FormField label="" name="">
                    <p>
                        We accept .DOC, .DOCX, .PDF, .RTF, .TXT, up to 10 MB.
                        <br />We do not accept scanned documents, images, or resumes containing images and/or icons.
                        <br /> Questions? Contact <a href={`mailto:${Contacts.MembershipTeam.address}`}>{Contacts.MembershipTeam.name}</a>.
                    </p>
                </Comp.Editors.FormField>

                <hr />
                <h2>Desired Position</h2>

                <Comp.Editors.RadioOrCheckListField formComponent={this} items={categories} listCss="options-h" name="categoryId" type="radio" />
                <Comp.Editors.TextField formComponent={this} name="title" />

                <hr />
                <h2>Cover letter</h2>

                <Comp.Editors.FormField label="" name="">
                    <p>
                        Introduce yourself to prospective employers with a brief summary of your goals and
                        qualifications. Completing this section will help prospective employers find you.
                    </p>
                </Comp.Editors.FormField>

                <Comp.Editors.RichTextField formComponent={this} name="coverLetter" />

                <hr />
                <h2>Education &amp; Training</h2>

                <EducationEditor formComponent={this} name="education" />

                <hr />
                <h2>Experience</h2>

                <ExperienceEditor formComponent={this} name="experience" />

                <hr />
                <h2>Relocation Preference(s)</h2>

                <RelocationEditor api={this.props.api} countries={this.props.countries} formComponent={this} name="relocationPref" />

                {subscribeForm}

                <hr />

                <Comp.Editors.SubmitField
                    cancelLink={this.props.cancelLink}
                    showProcessing={this.state.formProcessing}
                    label={this.props.isUpdate ? "Save" : "Continue"}
                />

            </Comp.Validation.ValidatedForm>;
    }

    private clearResumeCV(file: M.Upload.MediaMin) {
        const qp = { queryParams: { guid: file.guid, deleteMedia: true }};
        return this.props.api.delete<boolean>(Api.endpoints.media.media, qp);
    }

    private handleValidSubmit(model: Forms.CareerCenter.PostResumeData) {
        const educations = model.education
            .filter((e) => !(e.isDelete && e.id === 0))
            .map((e) => {
                return {
                    isDelete: e.isDelete,
                    id: e.id,
                    completedOn: e.completedOn,
                    organization: e.organization,
                    typeId: e.typeId,
                };
            });

        const experiences = model.experience
            .filter((e) => !(e.isDelete && e.id === 0))
            .map((e) => {
                return {
                    isDelete: e.isDelete,
                    id: e.id,
                    organization: e.organization,
                    position: e.position,
                };
            });

        const relocationPrefs = model.relocationPref
            .filter((r) => !(r.isDelete && r.id === 0))
            .map((r) => {
                return {
                    isDelete: r.isDelete,
                    id: r.id,
                    city: r.location.city,
                    countryCode: r.location.countryCode
                        ? (r.location.countryCode as any).value
                        : undefined,
                    state: r.location.state,
                    region: r.region ? (r.region as any).value : undefined,
                };
            });

        const body = {
            categoryId: model.categoryId,
            coverLetter: model.coverLetter,
            educations,
            experiences,
            mediaGuid: model.cv ? model.cv.guid : undefined,
            relocationPrefs,
            subscribe: model.subscribe,
            title: model.title,
        };

        this.props.onSubmit(model, body);
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/postResume/components/PostResumeForm.tsx